const subscribers = new Map()

/**
 * Subscribe to be notified if an action is triggered
 * @param action {Action}
 * @param callback {function}
 */
export function subscribe(action, callback) {
  if (subscribers.has(action)) {
    const set = subscribers.get(action)
    if (set) {
      set.add(callback)
    }
  } else {
    subscribers.set(action, new Set([callback]))
  }
}

/**
 * Unsubscribe from an action you started watching
 * @param action {Action}
 * @param callback {function}
 */
export function unsubscribe(action, callback) {
  const set = subscribers.get(action)
  if (set) set.delete(callback)
}

/**
 * Dispatch an action to notify all subscribers
 * @param action {string}
 * @param payload {*}
 */
export function dispatch(action, payload) {
  const targets = subscribers.get(action)
  if (targets) {
    targets.forEach(cb => cb(payload))
    return true
  }
  return false
}

/**
 * Remove all subscribers
 */
export function destroy() {
  subscribers.clear()
}



// WEBPACK FOOTER //
// ./src/hooks/dispatcher.js